<template>
  <div class="router">
    <div class="filter">
      <div>筛选</div>
      <el-select class="select" v-model="searchVal" placeholder="请选择" @change="searchImg(),searchPerson()">
        <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-date-picker v-model="monthVal" type="month" value-format="yyyy-MM" placeholder="选择月" @change="searchPerson(),searchImg()">
      </el-date-picker>
      <el-radio-group v-model="radioVal">
        <el-radio label="praise">用户好评</el-radio>
        <el-radio label="share">用户分享</el-radio>
      </el-radio-group>
      <button class="search" @click="searchImg">搜索</button>
    </div>
    <div class="content">
      <div class="title">
        <div>共{{list.count || 0}}个</div>
        <template v-if="staffInfo">
          <div>班主任总负责人数：{{staffInfo.student_count}}</div>
          <div v-if="radioVal == 'praise'">总好评率：{{((staffInfo.praise_count/staffInfo.student_count)*100).toFixed(2)}}%</div>
          <div v-else>总分享率：{{((staffInfo.share_count/staffInfo.student_count)*100).toFixed(2)}}%</div>
          <template v-if="monthVal">
            <div v-if="radioVal == 'praise'">{{monthVal}}月好评率：{{((staffInfo.month_praise_count/staffInfo.student_count)*100).toFixed(2)}}%</div>
            <div v-else>{{monthVal}}月分享率：{{((staffInfo.month_share_count/staffInfo.student_count)*100).toFixed(2)}}%</div>
          </template>
        </template>

      </div>

      <div class="imgList">
        <el-image style="width:120px;height:253px;margin-right:30px;margin-bottom:20px" @click="imageViewer(index,item.image)" fit="cover" v-for="(item,index) in list.results" :key="item.pk" :src="item.image" :preview-src-list="preList">
        </el-image>
      </div>
      <div class="block">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage" :total="total" :page-size="20">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { axiosGet } from "./../common/http.js";
export default {
  data() {
    return {
      searchVal: "", //查询的手机号或者名字
      monthVal: "", //查询的月份
      radioVal: "praise", //查询分类
      list: "",//
      srcList: [],//所有图片
      preList: [],//查看的列表
      currentPage: 1,//当前页码
      total: 1,//总共

      staffInfo: "",
      selectOptions: [{
        value: '17690804115',
        label: '李晓旋'
      }, {
        value: '15359967805',
        label: '小朱'
      }, {
        value: '18135675982',
        label: '张盼盼'
      }, {
        value: '18301322400',
        label: '宋果乐'
      },{
        value: '18301306134',
        label: '张敏'
      },{
        value: '15235127047',
        label: '英姿'
      },{
        value: '18211070884',
        label: '刘绅'
      },{
        value: '15702490287',
        label: '何思皖'
      },{
        value: '13259161997',
        label: '许拉比尔'
      }],
      breadcrumb: [
        {
          path: "",
          name: "学生管理"
        },
        {
          path: "/GoodReputation",
          name: "好评分享"
        }
      ] //面包屑
    };
  },
  methods: {
    ...mapActions(["changeBreadcrumb", "changeMenu", "changeSub"]),
    searchImg() {
      axiosGet("/server/job_management/list_material/", {
        search: this.searchVal,
        month: this.monthVal,
        source: this.radioVal,
        page: this.currentPage,
        page_size: 20
      })
        .then(res => {
          this.list = res.data
          this.total = res.data.count
          this.srcList = []
          res.data.results.forEach(ele => {
            this.srcList.push(ele.image)
          });
        })
    },
    searchPerson() {
      axiosGet("/server/job_management/promotion_user_info/", {
        username: this.searchVal,
        month: this.monthVal
      })
        .then(res => {
          this.staffInfo = res.data
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchImg()
    },
    imageViewer(index, src) {
      this.preList = []
      this.preList = Object.assign([], this.srcList);
      for (let i = 0; i < index; i++) {
        let moveSrc = this.preList.shift()
        this.preList.push(moveSrc)
      }
    }
  },
  computed: {
    ...mapState({
      courseActive: state => state.menu.courseActive
    })
  },
  created() {
    this.changeBreadcrumb(this.breadcrumb);
    this.changeMenu(7); //将menuActive设置为当前页
    this.changeSub(3);
    this.searchImg()

  }
};
</script>
<style lang="stylus" scoped>
$commonColor = #5F0AFF
.filter
  display flex
  align-items center
  height 80px
  border-radius 10px
  background #fff
  font-size 20px
  padding-left 20px
  /deep/.el-radio-group
    margin 0 10px
  .select
    margin 0 20px
  .search
    height 36px
    width 80px
    font-size 16px
    color #fff
    border-radius 18px
    background $commonColor
    cursor pointer
  input
    height 36px
    border-radius 18px
    background #ECF3FF
    font-size 16px
    color #999999
    width 230px
    padding 0
    padding-left 10px
    border none
    margin-left 10px
    margin-right 17px
.content
  margin-top 20px
  padding 30px 20px
  border-radius 10px
  background #fff
  font-size 18px
  color #333333
  .title
    display flex
    div
      margin-right 50px
  .imgList
    margin-top 35px
    display flex
    flex-wrap wrap
    img
      display block
      width 120px
      margin-right 20px
  .block
    text-align center
@media screen and (max-width: 1366px)
  .content table th, .content table td
    font-size 12px
</style>

